/** Portadas prediseñadas: negro con vetas rojas, sin imágenes (CSS puro). */

export const COVER_PRESETS = [
  {
    id: "obsidiana",
    name: "Obsidiana",
    background: `
      radial-gradient(120% 90% at 18% 0%, rgba(255,150,60,0.20) 0%, transparent 58%),
      linear-gradient(114deg, transparent 48.5%, rgba(255,150,60,0.55) 49%, transparent 49.5%),
      linear-gradient(101deg, transparent 61.4%, rgba(255,150,60,0.28) 62%, transparent 62.6%),
      linear-gradient(132deg, transparent 29.4%, rgba(255,190,130,0.22) 30%, transparent 30.6%),
      linear-gradient(160deg, #0B0B10 0%, #15110A 58%, #07070A 100%)`,
  },
  {
    id: "brasa",
    name: "Brasa",
    background: `
      radial-gradient(90% 120% at 82% 110%, rgba(176,26,38,0.34) 0%, transparent 62%),
      linear-gradient(72deg, transparent 39.5%, rgba(255,110,96,0.4) 40%, transparent 40.5%),
      linear-gradient(86deg, transparent 70.6%, rgba(255,150,60,0.3) 71%, transparent 71.5%),
      linear-gradient(200deg, #090A0C 0%, #1A1409 62%, #060608 100%)`,
  },
  {
    id: "vino",
    name: "Vino",
    background: `
      radial-gradient(130% 100% at 50% 0%, rgba(120,18,48,0.3) 0%, transparent 62%),
      linear-gradient(148deg, transparent 35.5%, rgba(214,96,120,0.22) 36%, transparent 36.6%),
      linear-gradient(126deg, transparent 56.4%, rgba(150,22,56,0.45) 57%, transparent 57.6%),
      linear-gradient(170deg, #0A080C 0%, #16110A 55%, #050406 100%)`,
  },
  {
    id: "grieta",
    name: "Grieta",
    background: `
      linear-gradient(97deg, transparent 32.4%, rgba(236,120,120,0.5) 32.8%, transparent 33.2%),
      linear-gradient(106deg, transparent 33.8%, rgba(255,150,60,0.28) 34.2%, transparent 35%),
      linear-gradient(88deg, transparent 66.5%, rgba(255,150,60,0.38) 67%, transparent 67.6%),
      linear-gradient(94deg, transparent 80.4%, rgba(255,140,140,0.18) 81%, transparent 81.6%),
      linear-gradient(185deg, #0C0C11 0%, #0E0E13 60%, #060609 100%)`,
  },
  {
    id: "humo",
    name: "Humo",
    background: `
      radial-gradient(70% 90% at 25% 30%, rgba(255,150,60,0.16) 0%, transparent 60%),
      radial-gradient(60% 80% at 78% 70%, rgba(90,24,40,0.3) 0%, transparent 62%),
      linear-gradient(120deg, transparent 51.6%, rgba(255,190,130,0.14) 52%, transparent 52.6%),
      linear-gradient(200deg, #08080B 0%, #121014 55%, #07070A 100%)`,
  },
  {
    id: "ceniza",
    name: "Ceniza",
    background: `
      linear-gradient(118deg, transparent 44.6%, rgba(255,255,255,0.09) 45%, transparent 45.5%),
      linear-gradient(118deg, transparent 57.6%, rgba(255,150,60,0.34) 58%, transparent 58.6%),
      radial-gradient(100% 120% at 100% 0%, rgba(60,60,70,0.4) 0%, transparent 60%),
      linear-gradient(165deg, #0A0A0D 0%, #131318 60%, #06060A 100%)`,
  },
];

const PRESETS = Object.fromEntries(COVER_PRESETS.map((p) => [p.id, p]));

const hash = (text = "") => {
  let h = 0;
  for (let i = 0; i < text.length; i += 1) h = (h * 31 + text.charCodeAt(i)) % 99991;
  return h;
};

/** Estilo de la portada: foto subida, portada prediseñada o una por defecto
 *  elegida de forma estable según el usuario. */
export const coverStyle = (cover, key = "", mediaUrl = (u) => u) => {
  if (cover && cover.startsWith("preset:")) {
    const p = PRESETS[cover.slice(7)];
    if (p) return { background: p.background };
  }
  if (cover) return { background: `url(${mediaUrl(cover)}) center/cover no-repeat` };
  return { background: COVER_PRESETS[hash(key) % COVER_PRESETS.length].background };
};
